import { Component, Input } from '@angular/core';
import { getEmmaDocsUrl } from '@emma-helpers/emma-utils';
import { sectionAnimations } from '@platform/helpers/animations.helper';

@Component({
    selector: 'emma-form-block',
    templateUrl: './emma-form-block.component.html',
    animations: [...sectionAnimations],
    standalone: false
})
export class EMMAFormBlockComponent {
  @Input() isNewFeature = false;
  @Input() isFirst = false;
  @Input() isLast = false;
  @Input() headTitle = '';
  @Input() titleIcon = '';
  @Input() description = '';
  @Input() descriptionHighlight = false;
  @Input() descriptionHighlightText = '';

  @Input() descriptionLink = false;
  @Input() descriptionHelpLink = getEmmaDocsUrl();
  @Input() descriptionHelpLinkText = $localize`Saber más`;

  @Input() copyContent = '';

  @Input() powerAdminBlock = '';

  @Input() titleModalVideoEmbed = '';
  @Input() youtubeVideoEmbed = '';
}
